import "./src/css/style.css";
import React from "react";

// Load Montserrat typeface
require("typeface-montserrat");
// Load Stylish typeface
require("typeface-stylish");

export const wrapPageElement = ({ element }) => <>{element}</>;
